module.exports = __webpack_public_path__ + "static/media/questioner-talk.d887f798.gif";